var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaussuresDeScurit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_6",
    "data-name": "Calque 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1448.95 1003.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#354140;}.cls-4{fill:#2b3333;}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_86);}.cls-6{fill:#ebec6d;}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_94);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-314.76 -570)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360,1126q-11-120.39,22-204c-1.06-27.06,0-51.36,15-57,0,0,8-99,25-116,0-12,22-30,49-3,19-35,92-65,124-11s36,55,36,55V755s3-71,73-77c20,0,52-36,57-41s46-40,96-21c20,8,33,16,50,59s29,64,29,64,18-17,27-12,31,30,39,53c9-3,32,23,28,34,8,13,29,42,29,42,17-10,44,22,36,35l56,52c11-9,38,15,29,27l59,44c13-10,47,17,34,29l35,27,10-4s43,21,46,24,4,16,4,16,54,22,69,25,12,21,12,21,124-6,224,44c58,31,82,76,73,146,6,4,12,3,14,11s6,65,2,83-48,65-162,95-322,43-334,42a21.8,21.8,0,0,0-1-6s-72,10-105,6a21.8,21.8,0,0,0-1-6s-86,6-103,5a29.9,29.9,0,0,1-3-12s-80,7-90,2c0-6-1-16-1-16s-39,12-80-7c-1-9-2-20-2-20l-36,5-31-18-3-17-30,1-25-17,1-30s-35-34-93-39l-42,16-59-11v-16l-12-4-18,13-49-14-1-13-16-3-20,9-35-14-2-16-15,6-31-23,9-18-22,1-18-31s-2-64,0-67,4-3,4-3-9-7-7-19,4-30,13-31C337,1152,349,1123,360,1126Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_86",
    x1: 856.97,
    y1: 1134.55,
    x2: 746.99,
    y2: 1370.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#354140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#333e3d",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2d3635",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252b2b",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_94",
    x1: 587.26,
    y1: 732.11,
    x2: 500.43,
    y2: 918.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebec6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e8e76b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ddda64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#cdc458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#b5a548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#977e34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#937931"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chaussures de s\xE9curit\xE9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M360,1126q-11-120.39,22-204c-1.06-27.06,0-51.36,15-57,0,0,8-99,25-116,0-12,22-30,49-3,19-35,92-65,124-11s36,55,36,55V755s3-71,73-77c20,0,52-36,57-41s46-40,96-21c20,8,33,16,50,59s29,64,29,64,18-17,27-12,31,30,39,53c9-3,32,23,28,34,8,13,29,42,29,42,17-10,44,22,36,35l56,52c11-9,38,15,29,27l59,44c13-10,47,17,34,29l35,27,10-4s43,21,46,24,4,16,4,16,54,22,69,25,12,21,12,21,124-6,224,44c58,31,82,76,73,146,6,4,12,3,14,11s6,65,2,83-48,65-162,95-322,43-334,42a21.8,21.8,0,0,0-1-6s-72,10-105,6a21.8,21.8,0,0,0-1-6s-86,6-103,5a29.9,29.9,0,0,1-3-12s-80,7-90,2c0-6-1-16-1-16s-39,12-80-7c-1-9-2-20-2-20l-36,5-31-18-3-17-30,1-25-17,1-30s-35-34-93-39l-42,16-59-11v-16l-12-4-18,13-49-14-1-13-16-3-20,9-35-14-2-16-15,6-31-23,9-18-22,1-18-31s-2-64,0-67,4-3,4-3-9-7-7-19,4-30,13-31C337,1152,349,1123,360,1126Z",
    transform: "translate(-314.76 -570)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M815,818s317.48,289.8,360.74,309.9S1232,1177,1309,1145s-42.18-89.71-42.18-89.71S1107,954,1063,893,953,736,936,739c2-23-64-132-64-132H771L625,703l5,138,115-38,58,7Z",
    transform: "translate(-314.76 -570)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M360,1126s41.16,34,113,91c92,73,211,107,255,134s169.15,104.48,336,144c76,18,211,18,211,18s-44-194-122-240-553-104-707-215-98-83-98-83Z",
    transform: "translate(-314.76 -570)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336,1216s23,60,76,94,100,39,183,50,119,19,126,24,29,17,55,45,109.28,84.2,185,91c40,3,63-6,63-6s-204-60-267-111c-20-16-45-28-60-35s-145.3-55-207-98c-66-46-148-104-148-104l-18-9s-11,47-9,50S336,1216,336,1216Z",
    transform: "translate(-314.76 -570)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M422,749s-9,105,17,147,51,52,79,48,92-40,109-73,112-78,188-53c-31-20-59-24-92-15s-75,28-75,28-4.83-79.07,7-100c13-23,14.18-36.22,64-48,55-13,69-113,69-113L420,732Z",
    transform: "translate(-314.76 -570)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M759,710s-16-36,7-60c18.62-19.43,45-38,71-33s45,17,55,43-2,39-16,46S778,742,759,710Z",
    transform: "translate(-314.76 -570)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M744,1270c0,10.25,106,24.4,118,10-15-29-72-120-102-139,43,6,130,0,149-20-26-20-97-76-97-76s-47,34-122,15-166-69-166-69-9-2-5,6,63,21,120,86S744,1229,744,1270Z",
    transform: "translate(-314.76 -570)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M765,863s25-36,88-43,116,7,116,7,34.78-31.87,33-47c-2-17,32,20,30,32s-84,100-84,100c-6,6.53-38-12-36-24,21-19,29-30,29-30s-61-11-91,0-55,20-64,32C783,873,772,862,765,863Z",
    transform: "translate(-314.76 -570)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M875,951s-5-5-10-6,9-18,31-23,92-12,121-5c22-29,42-61,42-61l17-9,31,20-12,24s-23,28-26,29c19,9,44,25,52,39s-42-20-71-14c-11,11-26,34-26,34l107,4,22.79-41.51L1165,936l24,33-9,1-19,26s53,31,57,39c-19-8-49-16-65-19-15.68,12.17-30.81,30.94-35,43-2.94,8.45-32-11-29-18s19-29,19-29-41-9-67,0-44,15-57,26a16.42,16.42,0,0,1-13-8c-5-8-14-4-14-13s30-36,53-37c-5.86-3.52-6.35-9-10-11-8.82-5-15.54-4-12-9,5-7,16-20,16-20s-29-7-58,1-49,15-60,23C882,966,875,951,875,951Z",
    transform: "translate(-314.76 -570)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1068,1102c-8-2-27-6-12-17s90-37,156-21c13-15,25-36,27-50s37,2,41,10-7,19-7,19-15,31-20,35c28,4,55-8,55-8s10-13,14-12,52,39,52,39l-6,9s-16-12-31-11-112,34-154,85c-7,10-8,3-18,0s-28-10-16-23,46-45,45-65c-21,0-28-9-68-3-20.7,3.1-41.16,20.33-51,23C1067.39,1114.06,1068,1102,1068,1102Z",
    transform: "translate(-314.76 -570)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1296,1521s-46-245-166-282c77,36,114,5,127-6s134-80.11,187-83c55-3,101-6,101-6l184,52,30,113-13,30s-83,30-113,47-19,40-55,62S1421,1530,1296,1521Z",
    transform: "translate(-314.76 -570)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M630,841s-50,84-110,83-38-130-41-153,50-71,71-56,66,96.16,80,103.08Z",
    transform: "translate(-314.76 -570)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaussuresDeScurit);
export default __webpack_public_path__ + "static/media/chaussures_de_sécurité.9b3056ee02cb91e1fe90c33a7b1c0374.svg";
export { ForwardRef as ReactComponent };